import { forwardRef, useEffect } from "react";

const subtitles = [
    { text: "Ojos en todas partes.", start: 0.5, end: 2 },
    { text: "Una campaña del ministerio de comercio, industria y turismo.", start: 3, end: 7 },
    { text: "Para la prevención del Esna.", start: 8, end: 10 },
];

const SyncedSubtitle = forwardRef(
    (
        {
            onCloseCaptionChange = (_) => {},
        }, 
        ref
    ) => {

      useEffect(() => {
        const video = ref.current;
        if (!video) return;

        const handleTimeUpdate = () => {
            const currentTime = video.currentTime;
            const activeSubtitle = subtitles.find(
                (s) => currentTime >= s.start && currentTime <= s.end
            );
            onCloseCaptionChange(activeSubtitle ? activeSubtitle.text : "");
        };

        video.addEventListener("timeupdate", handleTimeUpdate);

        return () => {
            video.removeEventListener("timeupdate", handleTimeUpdate);
        };
    }, [onCloseCaptionChange, ref]);

    return (
        <>
        </>
    );
});

export default SyncedSubtitle;
